// extracted by mini-css-extract-plugin
export default {"main":"NextShowCard_main__t-gba","image":"NextShowCard_image__9di9r","info_next_shows":"NextShowCard_info_next_shows__xOnRE","icon":"NextShowCard_icon__Kh8ls"};